import { render, staticRenderFns } from "./VerifyApproval.vue?vue&type=template&id=5d5752f1&scoped=true"
import script from "./VerifyApproval.vue?vue&type=script&lang=js"
export * from "./VerifyApproval.vue?vue&type=script&lang=js"
import style0 from "./VerifyApproval.vue?vue&type=style&index=0&id=5d5752f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5752f1",
  null
  
)

export default component.exports